import React, { useEffect, useState } from "react";

// Approved Beer placeholder asset (frontend/public/image_url_beer_falls_back.png).
export const BEER_IMAGE_FALLBACK_SRC = "/image_url_beer_falls_back.png";
export const BEER_IMAGE_FALLBACK_ALT = "Upload Beer Image";

// Legacy records/lessons may still carry the old broken backend sentinel path
// ("/uploads/default_image_beer.jpg[/png]") that was written when no photo
// was found. That file never existed on disk, so treat it as "no image" too.
export function isMissingBeerImageUrl(imageUrl) {
  if (!imageUrl || imageUrl === "N/A") return true;
  return imageUrl.includes("default_image_beer");
}

export function resolveBeerImageUrl(imageUrl) {
  if (imageUrl.startsWith("http://") || imageUrl.startsWith("https://")) {
    return imageUrl;
  }
  const base = process.env.REACT_APP_IMAGE_BASE_URL || "";
  return `${base}${imageUrl.startsWith("/") ? "" : "/"}${imageUrl}`;
}

// Shared fallback image for every Beer image consumer (Manage Menu, Reference
// Menu, lesson questions): shows the approved placeholder for a missing/empty
// image_url, and swaps to it if the resolved URL fails to load.
export default function BeerImage({ src, alt, className, fallbackClassName }) {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [src]);

  if (isMissingBeerImageUrl(src) || failed) {
    return (
      <img
        src={BEER_IMAGE_FALLBACK_SRC}
        alt={BEER_IMAGE_FALLBACK_ALT}
        className={fallbackClassName || className}
      />
    );
  }

  return (
    <img
      src={resolveBeerImageUrl(src)}
      alt={alt || "beer"}
      referrerPolicy="no-referrer"
      className={className}
      onError={() => setFailed(true)}
    />
  );
}
